import React from 'react'
import { useState } from "react";
import { Button, Grid, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  getAllLocations,
  activationStatLocation,
  updateLocation,
  getLocationByID,
  addLocation,
  getAllCityBasedOnDistrict,
  getAllDistrict,
  getAllProvince
} from '../../Api/Location/Location.api';
import SearchInput from "../../Components/atoms/Input/SearchInput";
import { ReactComponent as Person } from "../../Assets/Images/Doctor2.svg";
import {
  Heading1,
  Heading3,
} from "../../Components/atoms/Typography/Heading/Heading";
import { BasicGrid } from "../../Components/organisms/BasicGrid/BasicGrid";
import ConfirmDialog from "../../Components/organisms/ConfirmDialog/ConfirmDialog";
import { permissionValidator, useAuth } from "../../Store/AuthContext";
import useApiData from "../../Utils/Hooks/useApiData";
import useLoadingState from "../../Utils/Hooks/useLodingState";
import useOverlayState from "../../Utils/Hooks/useOverlayState";
import { getColumns } from "./GridColumns";
import { AddLocation } from '../../Components/organisms/AddLocation/AddLocation';
import { ViewLocationDetails } from '../../Components/organisms/ViewLocationDetails/ViewLocationDetails';
 
export const LocationsGrid = () => {
const { OverlayState, openOverlay, closeOverlay } = useOverlayState();
const { LoadingState, startLoading, stopLoading } = useLoadingState();
const { state } = useAuth();
const [searchText, setSearchText] = useState("");
const { t } = useTranslation();
  const [pageData, setPageData] = useState({
    currentPage: 1,
    pageCount: 0,
    pageSize: 10,
    totalPages: 0,
    totalRecordsCount: 0,
  });
 
const apiCall = async () => {
    let langCode = new String(state?.lang?.code);
    const response = await getAllLocations({
      page: pageData.currentPage,
      size: pageData.pageSize,
      searchText: searchText,
      language: langCode.toUpperCase(),
    });
    if (response.type == 0) {
      return response;
    } else {
      throw new Error(response.message || "Failed to fetch Location data");
    }
  };
 
const { isLoading, data, error, refetch } = useApiData({
    apiCall: apiCall,
    dependency: [pageData.currentPage, pageData.pageSize, searchText],
    pagination: {
      isServerSidePagination: true,
      setApiData: (totalRecordsCount, pageSize, pageNumber, pagesCount) => {
        if (
          pageData.currentPage !== pageNumber ||
          pageSize !== pageData.pageSize
        ) {
          setPageData({
            ...pageData,
            currentPage:
              pageData.currentPage !== pageNumber
                ? pageNumber
                : pageData.currentPage,
            pageSize:
              pageSize !== pageData.pageSize ? pageSize : pageData.pageSize,
            totalPages: pagesCount,
            totalRecordsCount: totalRecordsCount,
          });
        } else {
          setPageData({
            ...pageData,
            totalPages: pagesCount,
            totalRecordsCount: totalRecordsCount,
          });
        }
      },
    },
  });
 
  const updateAccountStatus = async (record) => {
    startLoading({ btnName: "account-status-update" });
 
    await activationStatLocation({
      id: record?.id,
      activeStatus: !record?.isActive,
    }).then((response) => {
      openOverlay({
        mode: Number(response.type),
        messages: {
          title: record?.isActive
            ? "Inactivate location"
            : "Activate location",
          description:
            response.type == 0 && record?.isActive == true
              ? "Location inactivated successfully"
              : response.type != 0 && record?.isActive == true
              ? "Failed to inactivate location"
              : response.type == 0 && record?.isActive == false
              ? "Location activated successfully"
              : "Failed to activate location",
        },
      });
      response.type == 0 && refetch();
    });
    stopLoading();
  };
 
  const clickHandler = async (e, data) => {
  //  if (e != 1) startLoading({ btnName: "load" });
    if (e === 1) {
      // View location
      openOverlay({
        OverlayName: "view-Location",
        record: data,
        mode: "view",
      });
    } else if (e === 2) {
      // Edit location
      openOverlay({
        mode: "update",
        OverlayName: "New-Location",
        record: data,
      });
    } else if (e === 3 || e === 4) {
      // Show confirmation dialog for activate/deactivate
      const isCurrentlyActive = data?.isActive;
      openOverlay({
        OverlayName: "status-change-confirmation",
        record: data,
        messages: {
          title: isCurrentlyActive ? "Inactivate Location" : "Activate Location",
          description:`Are you sure you want to proceed?`,
        },
      });
    }
  };
 
  return (
    <>
      <Grid container direction={"column"}>
        <Grid item>
          <Stack direction={"row"} justifyContent={"space-between"} mb={2.8}>
            <Heading1 text={"Locations"} />
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
              <SearchInput
                width={"376px"}
                searchValue={searchText}
                placeholder={"Location ID, Location name, Province, District, City, Phone no."}
                getSearchText={(value) => {
                  setSearchText(value);
                  setPageData({ ...pageData, currentPage: 1 });
                }}
              />
 
              <Button
                disableTouchRipple
                variant="lightBlue"
                sx={{ borderRadius: "14px" }}
                onClick={() => {
                  openOverlay({ OverlayName: "New-Location" });
                }}
              >
                <Person style={{ marginRight: "10px" }} fill="#ffffff" />
                <Heading3
                  text={"Add Location"}
                  color="#ffffff"
                />
              </Button>
 
            </Stack>
          </Stack>
        </Grid>
 
      <Grid width="100%" item>
                <Paper
                  sx={{
                    padding: "20px 24px",
                    boxShadow: "0px 0px 25px 0px rgba(0, 0, 0, 0.05)",
                    position: "relative",
                    height: "100%",
                  }}
                >
                  <BasicGrid
                    // isError={error}
                    isLoading={isLoading || LoadingState.visible}
                    rowSelect={false}
                    data={data}
                    pageData={pageData}
                    columnArray={getColumns(t, clickHandler)}
                    allowSorting
                    allowPaging
                    field={["EmployeeID", "LastName"]}
                    onRowClick={(rowData) => {
                      openOverlay({
                        OverlayName: "view-Location",
                        record: rowData,
                        mode: "view",
                      });
                    }}
                    paginationClick={(pageNumber) => {
                      setPageData({ ...pageData, currentPage: pageNumber });
                    }}
                    pageSizeChange={(selectedPageSize) => {
                      setPageData({ ...pageData, currentPage: 1, pageSize: selectedPageSize });
                    }}
                  />
                </Paper>
              </Grid>  
      </Grid>
     
        {OverlayState.visible && OverlayState.OverlayName === "New-Location" && (
            <AddLocation
              close={closeOverlay}
              OpenDrawer={OverlayState.visible}
              mode={OverlayState.mode}
              data={OverlayState.record}
              loadLocations={refetch}
            />
        )}
 
        {OverlayState.visible &&
              !OverlayState.OverlayName &&
              OverlayState?.messages?.title && (
                <ConfirmDialog
                  isError={OverlayState.mode === "fail" || OverlayState.mode === 3}
                  title={OverlayState.messages?.title}
                  description={OverlayState.messages?.description}
                  open={OverlayState?.visible}
                  close={() => {
                    closeOverlay();
                  }}
                  onOkClick={() => {
                    closeOverlay();
                  }}
                />
        )}
 
        {OverlayState.visible &&
                OverlayState.OverlayName === "status-change-confirmation" &&
                OverlayState?.messages?.title && (
                  <ConfirmDialog
                    title={OverlayState.messages?.title}
                    description={OverlayState.messages?.description}
                    open={OverlayState?.visible}
                    close={closeOverlay}
                    onNoClick={closeOverlay}
                    onOkTitle={"Yes"}
                    onNoTitle={"No"}
                    onOkClick={async () => {
                      closeOverlay();
                      await updateAccountStatus(OverlayState.record);
                    }}
                  />
        )}
        {OverlayState.visible && OverlayState.OverlayName === "view-Location" && (
                <ViewLocationDetails
                  data={OverlayState.record}
                  close={closeOverlay}
                  OpenDrawer={OverlayState.visible}
                  loadDoctors={refetch}
                />
        )}
 
    </>
  )
}
 